export const CONTACT_EMAIL = "hello@blossomandgraze.co.uk";

export const MAILTO_URL =
  "mailto:hello@blossomandgraze.co.uk?subject=Enquiry&body=Hi%0A%0AI'd%20like%20to%20enquire%20about%20a%20booking.%0A%0ANumber%20of%20guests%3A%0AGrazing%20style%3A%0ADietary%20requirements%3A%0A%0AThanks";
